import React from 'react'
import HomeDashBoard from '../../../components/homeDashBoard'

function Home() {
	return <HomeDashBoard />
}

export default Home
